const { connect } = require('react-redux');
const { context } = require('app-context');
const Login = require('../components/Login');
const { push: Push, replace: Replace } = require('connected-react-router');
const RoutingTable = require('services/auth-management/routing-table');

const actions = context.actions;
const selectors = context.selectors.all;

module.exports = connect(
    (state) => ({
        authStatus: selectors.getAuthStatus(state),
        isAuthenticated: selectors.getIsAuthenticated(state),
        isVerified: selectors.getVerifiedStatus(state),
        isMainAppLoading: selectors.getMainAppLoading(state),
        hasCurrentUser: selectors.hasCurrentUser(state),
        hasCurrentSchool: selectors.hasCurrentSchool(state),
        loginContext: selectors.getLoginContext(state),
        signupContext: selectors.getSignupContext(state),
        rememberedEmail: RoutingTable.getLoginPrefillEmail({
            loginContext: selectors.getLoginContext(state)
        })
    }),
    {
        checkSchoolSSO: actions.signup.checkSchoolSSO,
        resendEmail: actions.signup.identify.resendEmail,
        onSubmit: actions.auth.login,
        onInvalidSubmit: actions.auth.loginInputFailure,
        updateLoginContext: actions.auth.updateLoginContext,
        updateSignupContext: actions.signup.updateContext,
        clearLoginMessage: () => actions.app.clearAppMessage({ key: 'login' }),
        setLoginMessage: ({ title, message }) => actions.app.setAppMessage({ key: 'login', title, message }),
        push: Push,
        replace: Replace
    }
)(Login);
